import { mdiArrowLeft, mdiLogout } from '../../components/icons';
import { useEffect } from 'preact/hooks';
import { useLocation, useRoute } from 'preact-iso';
import { Svg } from '../../components/Icon';
import { Spinner } from '../../components/ui';
import { attempt, loadPage, page, signOut, user } from '../../state';
import { Activity } from './Activity';
import { Appearance, PageSettings, SearchSettings } from './Appearance';
import { DataSettings } from './Data';
import { Security } from './Security';
import { Users } from './Users';

const TABS = [
  { id: 'appearance', label: 'Appearance', component: Appearance },
  { id: 'page', label: 'Page', component: PageSettings },
  { id: 'search', label: 'Search', component: SearchSettings },
  { id: 'security', label: 'Passkeys & sessions', component: Security },
  { id: 'data', label: 'Import & export', component: DataSettings },
  { id: 'activity', label: 'Activity', component: Activity },
  { id: 'users', label: 'Users', component: Users, admin: true },
] as const;

export function Settings() {
  const { route } = useLocation();
  const { params } = useRoute();
  const isAdmin = user.value?.role === 'admin';
  const tabs = TABS.filter((t) => !('admin' in t) || isAdmin);
  const active = tabs.find((t) => t.id === params.tab) ?? tabs[0]!;
  const Tab = active.component;

  useEffect(() => {
    if (!page.value) void attempt(loadPage);
  }, []);

  return (
    <main class="settings">
      <header class="settings-header">
        <a href="/" class="icon-button" aria-label="Back to start page" title="Back">
          <Svg path={mdiArrowLeft} />
        </a>
        <h1>Settings</h1>
        <span class="spacer" />
        <span class="muted">
          {user.value?.displayName} ({user.value?.username})
        </span>
        <button
          type="button"
          class="button"
          onClick={async () => {
            await attempt(signOut);
            route('/login', true);
          }}
        >
          <Svg path={mdiLogout} size={16} /> Sign out
        </button>
      </header>
      <div class="settings-layout">
        <nav class="settings-nav" aria-label="Settings sections">
          {tabs.map((t) => (
            <a
              key={t.id}
              href={`/settings/${t.id}`}
              class={t.id === active.id ? 'active' : ''}
              aria-current={t.id === active.id ? 'page' : undefined}
            >
              {t.label}
            </a>
          ))}
        </nav>
        <div class="settings-panel">{page.value ? <Tab /> : <Spinner />}</div>
      </div>
    </main>
  );
}
